import { StatusStyleCode } from '../common';

export type IAppInstancesStatus = {
    code: AppInstancesStatusCode,
    name: string,
    color: StatusStyleCode,
}

export enum AppInstancesStatusCode {
    Wait = 'wait_activation',
    Approved = 'approved',
    Active = 'active',
    Canceled = 'canceled',
}

export const AppInstancesStatusSpec: { [key in AppInstancesStatusCode]: Omit<IAppInstancesStatus, 'code'> } = {
    [AppInstancesStatusCode.Wait]: { name: 'Требует регистрации', color: StatusStyleCode.Yellow },
    [AppInstancesStatusCode.Approved]: { name: 'Зарегистрировано', color: StatusStyleCode.Blue },
    [AppInstancesStatusCode.Active]: { name: 'Активное', color: StatusStyleCode.Green },
    [AppInstancesStatusCode.Canceled]: { name: 'Отменённое', color: StatusStyleCode.Red },
}

export const AppInstancesStatusList: IAppInstancesStatus[] = Object.keys(AppInstancesStatusSpec).map(code => ({
    ...AppInstancesStatusSpec[code as keyof typeof AppInstancesStatusSpec],
    code: code as AppInstancesStatusCode,
}));

export enum AppInstancesSettingCode {
    Shell = 'shell',
    Scada = 'scada_service',
}

export const AppInstancesSettingList = [
    {
        code: AppInstancesSettingCode.Shell,
        name: 'Shell',
    },
    {
        code: AppInstancesSettingCode.Scada,
        name: 'Scada сервис',
    },
]